<form [formGroup]="form">
    <sl-label color="dark" multiline i18n>Enter the following details to create an organization with a 30 days free trial period.</sl-label>
    <div class="grid gap-4 mt-6">
        <sl-input formControlName="name" label="Name" placeholder="Enter name of the organization" i18n-label i18n-placeholder></sl-input>
        <sl-select formControlName="countryCode" label="Country" i18n-label>
            <sl-menu-item value="DK" i18n>Denmark</sl-menu-item>
            <sl-menu-item value="FO" i18n>Faroe Islands</sl-menu-item>
            <sl-menu-item value="NO" i18n>Norway</sl-menu-item>
        </sl-select>
        <sl-input formControlName="registrationNo" label="Tax Id" placeholder="Enter the organizations tax id"
            help-text="Tax identification number like VIES, EIN, TIN, CVR etc." i18n-label i18n-placeholder i18n-help-text></sl-input>
    </div>

    <div class="text-right mt-8">
        <sl-button i18n (click)="cancel()">Cancel</sl-button>
        <sl-button class="ml-3" type="primary" i18n [disabled]="form.invalid" (click)="save()" [loading]="saving">Create</sl-button>
    </div>
</form>